interface ShibHorizDividerProps {
  className?: string;
}
const ShibHorizDivider = ({ className }: ShibHorizDividerProps) => {
  return <div className={`border-t-1 w-full border-[#2D3659] border-opacity-80 ${className}`} />;
};

export default ShibHorizDivider;
